import React from "react";
import { useAppText } from "src/commun/composants/AppText";
import AppRow from "src/commun/composants/grille/AppRow";
import styles from "./AppTuile.scss";
import AppCol from "src/commun/composants/grille/AppCol";
import { useAppState } from "src/app/state/StateProvider";
import { ActiveService } from "src/domain/User";
import { getServiceIcon } from "src/commun/utils/iconUtils";
import { goToUrl } from "src/app/menu/menuutil";
import { useNavigate } from "react-router-dom";

export type AppTuileBandeauProps = {
  service: ActiveService;
}

const AppTuileBandeau = ({ service }: AppTuileBandeauProps) => {
  const { tString } = useAppText();
  const navigate = useNavigate();

  const [{ langue, menu }] = useAppState();

  let label;
  let description;
  if (langue === "fr") {
    label = service.labelFr;
    description = service.descriptionFr;
  } else if (langue === "de") {
    label = service.labelDe;
    description = service.descriptionDe;
  } else {
    label = service.labelEn;
    description = service.descriptionEn;
  }

  return (
    <AppCol
      lg
      className={`${styles.tuileBandeauContainer}`}
      onClick={() => {
        goToUrl(service.url, false, navigate)
      }}>
      <AppRow>
        <AppCol xs="auto" className={styles.iconContainer}>
          <img src={getServiceIcon(menu?.imageBaseURl || "", service.serviceCode)} width="30" height="30" alt={label}/>
        </AppCol>
        <AppCol xs="auto" className={styles.serviceName}>
          <span className={styles.serviceName}>{label}</span>
        </AppCol>
        <AppCol md className={styles.descriptionText}>
          {description}
        </AppCol>
        <AppCol md={"auto"} className={styles.arrowLineBandeau}>
          <span className={styles.lblSabonner} title={tString("global.poursuivre")}>
            {tString("global.poursuivre")}
          </span>
        </AppCol>
      </AppRow>
    </AppCol>
  );
};

export default AppTuileBandeau;
